module.exports = __webpack_public_path__ + "media/rating-scale.d072189c.webm";